import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBCol, MDBContainer, MDBRow} from 'mdb-react-ui-kit'
import OrderNameSvg from '../../../../../../src/assets/sections/Vector.svg'
import OrderStatus from '../../../../../../src/assets/sections/detail.svg'
import OrderWallet from '../../../../../../src/assets/sections/Wallet.svg'
import "./Installment.css"
import PrivateRequest from '../../../api/PrivateRequest'
import NumberFormat from 'react-number-format';
import Skeleton from 'react-loading-skeleton'
import noOrder from '../../../../../assets/order/no-order.svg'

const Installment: React.FC = () => {

  const [StockOrders, setStockOrders] = useState<any>(null)

  useEffect(()=> {
    PrivateRequest().post('order/registered').then((res) => {
      setStockOrders(res.data.data.slice(0,3))
      console.log('why', res.data.data)
    }).catch(err => {
      console.log('err list order', err)
    })
  }, [])


  const [payment, setPayment] = useState([
    {
      id:1,
      row: '1',
      title: 'قسط آبان ماه ',
      desc: 'قسط سوم با کد 50500',
      price: 50000,
      date: '1400.4.7',
      status: '',
      pay: '',
    },
    {
      id:2,
      row: '2',
      title: 'قسط آذر ماه ',
      desc: 'قسط چهارم با کد 50501',
      price: 90000,
      date: '1400.4.8',
      status: '',
      pay: '',
    },
    {
      id:3,
      row: '3',
      title: 'قسط دی ماه ',
      desc: 'قسط پنجم با کد 50502',
      price: 100000,
      date: '1400.4.9',
      status: '',
      pay: '',
    },
    {
      id:4,
      row: '4',
      title: 'قسط بهمن ماه ',
      desc: 'قسط هفتم با کد 50503',
      price: 120000,
      date: '1400.4.10',
      status: '',
      pay: '',
    },
  ])

  return (
    <MDBContainer dir='rtl'>
      <MDBRow>
        {StockOrders !== null && StockOrders.length > 0 ? StockOrders.map((orderItem:any, index:number) => (
          <MDBCol lg={'4'}>
            <MDBCard className={'rounded bg-wave-card-order'} shadow={'md'}>
              <MDBCardBody dir={'rtl'}>
                <MDBCardText >
                  <div className={'flex-col flex'}>
                    <div className={'text-right flex items-center'}>
                      <div className={'ml-2'}>
                        <img src={OrderNameSvg}/>
                      </div>
                      <br />
                      <br />
                      <br />
                      <div>
                        <span className={'font-light text-gray'}>   عنوان سفارش </span>
                      </div>
                    </div>
                    <div className={'text-right'}>
                      <h3 className={'ir-black'}>  {orderItem.stock.stock_name} </h3>
                    </div>
                  </div>
                  <div className={'flex-col flex'}>
                    <div className={'text-right flex items-center'}>
                      <div className={'ml-2'}>
                        <img src={OrderWallet}/>
                      </div>
                      <br />
                      <br />
                      <br />
                      <div>
                        <span className={'font-light text-gray'}>   مبلغ سفارش </span>
                      </div>
                    </div>
                    <div className={'text-right'}>
                      <h3 className={'ir-black'}>
                        <NumberFormat
                          className={'ir-black'}
                          displayType={'text'}
                          thousandSeparator={true}
                          inputMode={'numeric'}
                          value={orderItem.order_price}
                        />
                        <span className={'text-sm mr-2'}>تومان</span>
                          </h3>
                    </div>
                  </div>
                  <div className={'flex-col flex'}>
                    <div className={'text-right flex items-center'}>
                      <div className={'ml-2'}>
                        <img src={OrderStatus}/>
                      </div>
                      <br />
                      <br />
                      <br />
                      <div>
                        <span className={'font-light text-gray'}>   وضعیت سفارش </span>
                      </div>
                    </div>
                    <div className={'text-right'}>
                      <h3 className={'ir-black text-warning'}>
                        {orderItem.is_clearing == 0 ? 'در انتظار پرداخت': (
                          <div className={'text-success p-1 rounded-lg'}>
                            تسویه شده
                          </div>
                        )}
                      </h3>
                    </div>
                  </div>
                </MDBCardText>
                <Link to={'/stock/orders'}>
                  <MDBBtn size={'small'} className={'rounded-pill bg-primary-pro'}>مشاهده سفارش</MDBBtn>
                </Link>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        )): (
          StockOrders && StockOrders.length < 1 ? (
            <div>
              <img src={noOrder} />
            </div>
          ): (
            <Skeleton width={'100%'} height={'20%'}/>
          )
        )}
      </MDBRow>
    </MDBContainer>
  )
}

export {Installment}
